import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default async function assignLead(assignedLeads) {
	console.log('assignedLeads', Object.keys(assignedLeads));
	var leadsEmails = Object.keys(assignedLeads);

	leadsEmails?.forEach((leadsEmail) => {
		var leadKey;
		firebaseRef
			.ref('/kavtek_leads/')
			.orderByChild('clientEmail')
			.equalTo(leadsEmail)
			.once('value', (snapshot) => {
				leadKey = Object.keys(snapshot.val())[0];
			});

		var leadRef = firebaseRef.ref('/kavtek_leads/' + leadKey);
		console.log('leadKey', leadKey);

		leadRef.update({
			leadToSalesAgent: assignedLeads[leadsEmail],
		});
	});
}
